import { render, staticRenderFns } from "./qrInfo.vue?vue&type=template&id=4a0cbc7c&scoped=true&"
import script from "./qrInfo.vue?vue&type=script&lang=js&"
export * from "./qrInfo.vue?vue&type=script&lang=js&"
import style0 from "./qrInfo.vue?vue&type=style&index=0&id=4a0cbc7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0cbc7c",
  null
  
)

export default component.exports